import { render, staticRenderFns } from "./SummaryTitle.vue?vue&type=template&id=f09ddf88&scoped=true"
import script from "./SummaryTitle.vue?vue&type=script&lang=js"
export * from "./SummaryTitle.vue?vue&type=script&lang=js"
import style0 from "./SummaryTitle.vue?vue&type=style&index=0&id=f09ddf88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09ddf88",
  null
  
)

export default component.exports